module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjI1IiBjeT0iMjUiIHI9IjI1IiBmaWxsPSIjRkVDRDA1Ii8+DQo8cGF0aCBkPSJNMTcuNTg4MiAyMS4zNDg2TDEzIDI3LjA3MzRMMjIuNTU4OCAzOUwzOSAxOC45NjMzTDM0LjQxMTggMTNMMjIuNTU4OCAyNy41NTA1TDE3LjU4ODIgMjEuMzQ4NloiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success-icon.svg
// module id = K7d9
// module chunks = 0